import React, { useEffect, useState } from 'react';

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import ReactTooltip from 'react-tooltip';
import { Checkbox, Divider } from 'react-md';

require("highcharts/modules/exporting")(Highcharts)
require("highcharts/modules/export-data")(Highcharts)
require("highcharts/modules/annotations")(Highcharts)
require("highcharts/highcharts-more.js")(Highcharts)

function BarChart({
    categories,
    selectedCat,
    selectedTopic,
    topicID,
    handleChangeSelectedCategory,
    width,
    height,
    showTooltip,
    isBarChart,
    handlePracticeCategorySelect
}) {

    const [seriesArr, setSeriesArr] = useState([])

    const getDataPoints = (catKey) => {
        let data = categories.map((cat, ) => {
            if (cat.key === catKey) {
                return {
                    y: cat.accuracyIndex,
                    color: cat.backgroundColor,
                    selected: selectedCat?.key === cat.key,
                }
            }
            return  {
                y: 0,
                color: "red",
            };
        })
        return data;
    }

    // console.debug("categories", categories)

    return (
        <div className='position-relative'>
            {/* <div className="text-align-center fontClass-18"><b>{selectedTopic?.name}</b>(Topic)</div>
            <div className="text-align-center fontClass-12 mt-2">Categories by Accuracy & Time </div> */}
            <HighchartsReact
                highcharts={Highcharts}
                style={{
                    backgroundColor: "red"
                }}
                options={{
                    // colors: ['#FFD700', '#efefef'],
                    credits: {
                        enabled: false,
                    },
                    navigation: {
                        buttonOptions: {
                            enabled: false
                        }
                    },

                    chart: {
                        type: "bar",
                        inverted: false,
                        polar: false,
                        // width: isBarChart ? 300 : null,
                        width: 350,
                        // height: isBarChart ? 400 : 500,
                    },
                    title: {
                        text: null,
                        align: "center",
                    },
                    tooltip: {
                        outside: true,
                    },

                    xAxis: {
                        minPadding: 0,
                        maxPadding: 0,
                        title: {
                            text: 'Categories',
                            style: {
                              fontWeight: 600,
                            }
                        },

                        labels: {
                            enabled: false,
                            align: "right",
                            useHTML: true,
                            allowOverlap: true,
                            step: 0,
                            y: 0,
                            x: 0,
                            style: {
                                fontSize: "12px",
                                textOverflow: 'none'
                            },
                            formatter: (data) => {
                                // console.debug("data===", data.value)
                                if (data?.value?.name === undefined) {
                                    return
                                }

                                let catName = data.value.label ?data.value.label : data.value.name

                                return catName
                            }
                        },
                        lineWidth: 0,
                        gridLineWidth: 0,
                        categories: categories?.map(cat => cat),
                    },
                    yAxis: {
                        labels: {
                            enabled: true,
                        },
                        title: {
                            text: 'Accuracy Index',
                            style: {
                              fontWeight: 600,
                            }
                        },
                        max: 100,
                        lineWidth: 0,
                        tickInterval: 25,
                        reversedStacks: false,
                        endOnTick: true,
                        showLastLabel: true,
                        lineWidth: isBarChart ? 1 : 0,
                        gridLineWidth: isBarChart ? 1: 0,
                    },

                    plotOptions: {
                        column: {
                            stacking: "normal",
                            borderWidth: 0,
                            pointPadding: 0,
                            pointWidth: 12,
                            borderRadius: 6,
                            // groupPadding: 0.8,
                        },
                        bar: {
                            // pointWidth: 20,
                        },
                        series: {
                            states: {
                                select: {
                                    color: null,
                                    borderColor: 'black',
                                    borderWidth: 2
                                },
                                hover: {
                                    color: null,
                                    borderColor: 'black',
                                    borderWidth: 2,
                                }
                            },
                            point: {
                                events: {
                                    click: function (data) {
                                        let catClicked = data?.point.category;
                                        if (catClicked?.key) {
                                            const index = categories?.findIndex(cat => cat.key === catClicked.key);
                                            handleChangeSelectedCategory(catClicked)
                                        }

                                    }
                                }
                            },
                            dataLabels: {
                        enabled: true,
                        color: '#000',
                        style: {fontWeight: 'bolder'},
                        formatter: function() {return this.x + ': ' + this.y},
                        inside: true,
                    }
                        }
                    },
                    tooltip: {
                        formatter: function (data) {
                            // console.debug("data---", data, this.y, this.x)
                            let catName = this.x.label ? this.x.label : this.x.name
                            if (catName === null || catName === undefined) {
                                return 
                            }
                            return `<div>
                            ${catName} <br/><div><b>Accuracy Index:</b> ${this.x.accuracyIndex.toFixed(0)}</div><br/><div><b>Time:</b> ${this.x.timeInSec}</div>
                        </div>`;
                        }
                    },
                    series: [
                        {
                            showInLegend: false,
                            allowPointSelect: false,
                            name: "Empty",
                            states: {
                                hover: {
                                    enabled: false,
                                },
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            data: [
                                ...(categories?.map((cat) => ({
                                    y: 100,
                                    color: "#efefef",
                                    selected: false,
                                })) || []),

                                // UNCOMMENT the following lines to show all the 8 circles irrespective of categories length
                               /*  ...(categories && categories.length < 8
                                    ? Array.from({ length: 8 - (categories.length || 0) }, () => ({
                                        y: 100,
                                        color: "#efefef",
                                        selected: false,
                                    }))
                                    : []), */
                            ],
                            // data: categories?.map((cat) => {
                            //     return {
                            //         y: 100 - cat.accuracyIndex,
                            //         color: "#efefef",
                            //     };
                            // }),
                        },
                        {
                            showInLegend: false,
                            allowPointSelect: true,
                            name: "Accuracy Index",
                            grouping: false,
                            dataLabels: {
                              enabled: true,
                              inside: true,
                              align: 'right',
                              // format: '{point.y}%',
                              formatter: function() {
                                    // console.debug("this.point.y", this.point.y)
                                    // Hide the label if y is zero
                                    if (this.point.y === 0) {
                                        return '';
                                    }

                                    // Display the label with the formatted y value
                                    return this.point.y.toFixed(0) + '%';
                                },
                              style: {
                                color: 'white',
                                textOutline: false,
                              }
                            },
                            data: [
                                ...(categories?.map((cat) => ({
                                    y: cat.accuracyIndex,
                                    color: cat.backgroundColor,
                                    selected: selectedCat?.key === cat.key,
                                })) || []),
                                ...(categories && categories.length < 8
                                    ? Array.from({ length: 8 - (categories.length || 0) }, () => ({
                                        y: 0,
                                        color: "",
                                        selected: false,
                                    }))
                                    : []),
                            ],
                        },
                    ],
                }}
            />

            {/* <div className='barchart-cat-list'>
                <h1>Category Name</h1>
            </div> */}

            <div className={`cat-list-pc cat-list-pc-bar`} style={{
                top:"60px",
                left:"102%"
            }}>
                {categories?.length < 8 ? 
                    [...categories, ...Array.from({ length: 8 - (categories.length || 0) }, () => null), ]
                    .map((cat, index) => {
                        if (cat === null) {
                            return <div className='hidden'>h</div>
                        }
                        return <div
                            className="single-cat-pc cursor-pointer py-0 my-0"
                            key={cat.key}
                        >
                        {cat !== null && categories[categories.length - 1].key === cat.key ? <div className='add-to-practice-label'>Add to Practice Set</div> : null}
                            <div className="d-flex justify-content-start align-items-center w-100">
                                <div
                                    onClick={() => {
                                        handleChangeSelectedCategory(cat)
                                    }}
                                    style={{
                                        flex: "0 0 auto",
                                        fontWeight: cat.key === selectedCat.key ? "900" : "",
                                    }}
                                    className='cursor-pointer'
                                >
                                    {cat.label ? cat.label : cat.name} ({cat.timeInSec} Sec)
                                </div>
                                <div style={{flex:"1 0", height:"1px",  background:"#D9D9D9"}}></div>
                            </div>
                            <div >
                                <ReactTooltip
                                    id={`add_to_practice_set_${cat.key}`}
                                    multiline={true}
                                    place="top"
                                    effect="float"
                                />
                                {/* <Checkbox id={index} checked={cat.checked} className="custom-checkbox" onChange={(val) => {
                                    console.debug("val", val)
                                    // handlePracticeCategorySelect(cat, val)
                                }}
                                    data-for={`add_to_practice_set_${cat.key}`}
                                    data-tip={cat.checked ? "Remove from practice set" : "Add to practice set"}
                                /> */}
                                <input type="checkbox" 
                                className='cursor-pointer d-block'
                                    id={index}
                                    name={cat.key}
                                    checked={cat.checked}
                                    onChange={event => {
                                        let val = event.target.checked;
                                        // console.debug("val", val)
                                        handlePracticeCategorySelect(cat, val)
                                    }}
                                />
                            </div>
                        </div>
                    })
                : [...categories]?.map((cat, index) => {
                    return (
                        <div
                            className="single-cat-pc cursor-pointer py-0 my-0"
                            key={cat.key}
                        >
                            <div className="d-flex justify-content-start align-items-center w-100">
                                <div
                                    onClick={() => {
                                        handleChangeSelectedCategory(cat)
                                    }}
                                    style={{
                                        flex: "0 0 auto",
                                        // width:'90%',
                                        fontWeight: cat.key === selectedCat.key ? "900" : "",
                                    }}
                                    className='cursor-pointer fontClass-12'
                                >
                                    {cat.label ? cat.label : cat.name} ({cat.timeInSec} Sec)
                                </div>
                                <div style={{flex:"1 0", height:"1px",  background:"#D9D9D9"}}></div>
                            </div>
                            <div >
                                <ReactTooltip
                                    id={`add_to_practice_set_${cat.key}`}
                                    multiline={true}
                                    place="top"
                                    effect="float"
                                />
                                {/* <Checkbox id={index} checked={cat.checked} className="custom-checkbox" onChange={(val) => {
                                    console.debug("val", val)
                                    // handlePracticeCategorySelect(cat, val)
                                }}
                                    data-for={`add_to_practice_set_${cat.key}`}
                                    data-tip={cat.checked ? "Remove from practice set" : "Add to practice set"}
                                /> */}
                                <input type="checkbox" 
                                className='cursor-pointer'
                                    id={index}
                                    name={cat.key}
                                    checked={cat.checked}
                                    onChange={event => {
                                        let val = event.target.checked;
                                        // console.debug("val", val)
                                        handlePracticeCategorySelect(cat, val)
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
                {/* {categories?.map((cat, index) => {
                    return (
                        <div
                            className="single-cat cursor-pointer py-0 my-0"
                            key={cat.key}
                        >
                            <div className="d-flex justify-content-center align-items-center w-100">
                                <div
                                    onClick={() => {
                                        // this.changeSelectedCategory(cat)
                                    }}
                                    className="w-100"
                                >
                                    {cat.label ? cat.label : cat.name}
                                </div>
                            </div>
                            <div >
                                <ReactTooltip
                                    id={`add_to_practice_set_${cat.key}`}
                                    multiline={true}
                                    place="top"
                                    effect="float"
                                />
                                <Checkbox id={index} checked={cat.checked} className="custom-checkbox" onChange={(val) => {
                                    console.debug("val", val)
                                    // this.handlePracticeCategorySelect(cat, val)
                                }}
                                    data-for={`add_to_practice_set_${cat.key}`}
                                    data-tip={cat.checked ? "Remove from practice set" : "Add to practice set"}
                                />
                            </div>
                        </div>
                    );
                })} */}
            </div>
        </div>

    );
}

export default BarChart
